// Vendors
import React, { useEffect, useState } from 'react';

// Config
import { GOOGLE_MAPS_API_KEY } from '../../config';

const LOADING_STATE_NONE = `NONE`;
const LOADING_STATE_BEGIN = `BEGIN`;
const LOADING_STATE_LOADED = `LOADED`;

const GoogleMapsLoader = ({ onLoad, render }) => {
  if (!render) return false;

  const loadingElement = <div style={{ height: '1140px' }} />;
  const googleMapsURL = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&v=3.exp&libraries=places,geometry`;

  const [loading, setLoading] = useState(LOADING_STATE_NONE);

  useEffect(() => {
    setLoading(LOADING_STATE_BEGIN);
    loadScript();
  }, []);

  function loadScript() {
    let script;
    const id = 'google-maps-api-js';
    const head = document.getElementsByTagName('head')[0];

    if (document.getElementById(id)) return;

    script = document.createElement('script');
    script.id = id;
    script.async = true;
    script.src = googleMapsURL;
    script.onload = handleScriptLoaded;

    head.appendChild(script);
  }

  function handleScriptLoaded() {
    if (onLoad) onLoad();
    return setLoading(LOADING_STATE_LOADED);
  }

  return (
    <>
      {loading !== LOADING_STATE_LOADED && loadingElement}
      {loading === LOADING_STATE_LOADED && render()}
    </>
  );
};

export default GoogleMapsLoader;
